import React from "react";
import { useSelector } from "react-redux";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  Grid,
} from "@mui/material";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import { confirmMessage, confirmTitle } from "../features/AppSlice";
import { config } from "../config";

const Confirmation = () => {
  const confirmationText = useSelector(confirmMessage);
  const confirmationHeader = useSelector(confirmTitle);
  const surveyURL = config.SURVEYLINK;
  //debugger;
  return (
    <Card>
      <CardHeader title={confirmationHeader} />
      <CardContent>
        <Typography sx={{ whiteSpace: "pre-wrap" }}>
          {confirmationText}
        </Typography>
        <br /> <br />
        <Grid container wrap="nowrap" justifyContent="space-around">
          {surveyURL !== "" ? (
            <Grid size={{ xs: 12 }} container justifyContent="center">
              <Button
                variant="contained"
                color="success"
                startIcon={
                  <PollOutlinedIcon aria-label="Key" fontSize="large" />
                }
                onClick={() =>
                  window.open(surveyURL, "_blank", "noopener,noreferrer")
                }
              >
                Please take a moment to complete a survey on your interaction.
              </Button>
            </Grid>
          ) : null}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Confirmation;
